<div class="container mx-auto flex justify-between items-center mb-4">
  <!-- Breadcrumb Navigation -->
  <nav class="flex items-center space-x-2 text-gray-600">
    <ng-container *ngFor="let item of breadcrumbs; let last = last">
      <a *ngIf="!last" [routerLink]="item.path" class="hover:text-gray-800 text-[#063970]">
        {{ t(item.label) }}
      </a>
      <svg *ngIf="!last" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20"
        fill="currentColor">
        <path fill-rule="evenodd"
          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
          clip-rule="evenodd" />
      </svg>
    </ng-container>
  </nav>

  <!-- Actions: Notifications, Langue & Aide -->
  <div class="flex items-center space-x-4">
    
    <!-- ============================= -->
    <!-- NOTIFICATIONS (ADMIN ONLY) -->
    <!-- ============================= -->
    <div class="relative" *ngIf="authService.isADMINProfile()">
      <!-- Icône de notification -->
      <button 
        (click)="toggleNotificationDropdown()" 
        class="relative p-2 hover:bg-gray-100 rounded-lg transition-colors">
        <!-- SVG Cloche -->
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2C11.4696 2 10.9609 2.21071 10.5858 2.58579C10.2107 2.96086 10 3.46957 10 4V4.539C8.67071 4.94719 7.50369 5.78456 6.67597 6.92545C5.84825 8.06635 5.40527 9.44864 5.414 10.868V15.138L4.707 15.846C4.61475 15.9383 4.54175 16.0478 4.49205 16.1681C4.44236 16.2884 4.41695 16.4171 4.41724 16.5471C4.41752 16.677 4.44351 16.8056 4.49374 16.9257C4.54396 17.0458 4.61746 17.1549 4.71 17.247C4.80255 17.339 4.91231 17.4121 5.03258 17.462C5.15285 17.5118 5.28138 17.5375 5.41134 17.5373C5.5413 17.5372 5.66977 17.5113 5.78991 17.4613C5.91005 17.4113 6.01962 17.338 6.112 17.246L7.414 15.943C7.5059 15.8507 7.61503 15.7778 7.73503 15.7283C7.85504 15.6789 7.98347 15.6539 8.113 15.654H15.887C16.0165 15.6539 16.145 15.6789 16.265 15.7283C16.385 15.7778 16.4941 15.8507 16.586 15.943L17.888 17.246C17.9804 17.338 18.09 17.4113 18.2101 17.4613C18.3302 17.5113 18.4587 17.5372 18.5887 17.5373C18.7186 17.5375 18.8472 17.5118 18.9674 17.462C19.0877 17.4121 19.1975 17.339 19.29 17.247C19.3825 17.1549 19.456 17.0458 19.5063 16.9257C19.5565 16.8056 19.5825 16.677 19.5828 16.5471C19.583 16.4171 19.5576 16.2884 19.5079 16.1681C19.4583 16.0478 19.3852 15.9383 19.293 15.846L18.586 15.138V10.868C18.5947 9.44864 18.1518 8.06635 17.324 6.92545C16.4963 5.78456 15.3293 4.94719 14 4.539V4C14 3.46957 13.7893 2.96086 13.4142 2.58579C13.0391 2.21071 12.5304 2 12 2ZM10 19C10 19.5304 10.2107 20.0391 10.5858 20.4142C10.9609 20.7893 11.4696 21 12 21C12.5304 21 13.0391 20.7893 13.4142 20.4142C13.7893 20.0391 14 19.5304 14 19H10Z" fill="#063970"/>
        </svg>
        
        <!-- Badge de compteur (si notifications non lues) -->
        <span 
          *ngIf="unreadCount > 0" 
          class="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full min-w-[20px] h-5 flex items-center justify-center px-1.5 shadow-lg">
          {{ unreadCount > 99 ? '99+' : unreadCount }}
        </span>
      </button>

      <!-- Dropdown des notifications -->
      <div 
        *ngIf="showNotificationDropdown"
        class="absolute right-0 mt-2 w-96 bg-white rounded-lg shadow-xl border border-gray-200 z-50 max-h-[500px] flex flex-col">
        
        <!-- Header du dropdown -->
        <div class="px-4 py-3 border-b border-gray-200 flex items-center justify-between bg-gray-50 rounded-t-lg">
          <h3 class="font-semibold text-gray-900 text-sm flex items-center">
            <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" style="color: #063970">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path>
            </svg>
            {{ t('notifications.title') }}
          </h3>
          <button 
            (click)="closeNotificationDropdown()" 
            class="text-gray-400 hover:text-gray-600 transition-colors">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>

        <!-- Liste des notifications (scrollable) -->
        <div class="overflow-y-auto flex-1" style="max-height: 400px;">
          <!-- Loading state -->
          <div *ngIf="loadingNotifications" class="flex items-center justify-center py-12">
            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-[#063970]"></div>
          </div>

          <!-- Liste des notifications -->
          <div *ngIf="!loadingNotifications && notifications.length > 0" class="divide-y divide-gray-100">
            <div 
              *ngFor="let notification of notifications" 
              (click)="openNotificationDetail(notification)"
              class="px-4 py-3 hover:bg-gray-50 cursor-pointer transition-colors">
              
              <div class="flex items-start space-x-3">
                <!-- Indicateur non lu -->
                <div class="flex-shrink-0 mt-1">
                  <div 
                    [class.bg-[#063970]]="!notification.read"
                    [class.bg-gray-300]="notification.read"
                    class="w-2 h-2 rounded-full"></div>
                </div>

                <!-- Contenu de la notification -->
                <div class="flex-1 min-w-0">
                  <p class="text-sm font-medium text-gray-900 truncate">
                    {{ notification.libelle }}
                  </p>
                  <p class="text-xs text-gray-600 line-clamp-2 mt-1">
                    {{ notification.description }}
                  </p>
                  <p class="text-xs text-gray-400 mt-1">
                    {{ formatTime(notification.date) }}
                  </p>
                </div>

                <!-- Temps relatif -->
                <div class="flex-shrink-0 text-xs text-gray-400">
                  {{ formatRelativeTime(notification.date) }}
                </div>
              </div>
            </div>
          </div>

          <!-- État vide -->
          <div *ngIf="!loadingNotifications && notifications.length === 0" 
            class="flex flex-col items-center justify-center py-12 text-gray-500">
            <svg class="w-12 h-12 mb-3 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path>
            </svg>
            <p class="text-sm font-medium">{{ t('notifications.noNotifications') }}</p>
            <p class="text-xs mt-1">{{ t('notifications.allCaughtUp') }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Select de langue avec drapeaux -->
    <div class="relative">
      <select (change)="onLanguageChange($event)" [value]="currentLang()"
        class="appearance-none h-9 pl-9 pr-8 py-1 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:border-[#063970] focus:outline-none focus:ring-2 focus:ring-[#063970] focus:border-[#063970] transition-all cursor-pointer">
        <option value="FR">FR</option>
        <option value="EN">En</option>
      </select>
      <!-- Icône drapeau à gauche -->
      <div class="absolute left-2 top-1/2 transform -translate-y-1/2 pointer-events-none">
        <svg *ngIf="currentLang() === 'FR'" width="20" height="15" viewBox="0 0 900 600"
          xmlns="http://www.w3.org/2000/svg">
          <rect width="900" height="600" fill="#ED2939" />
          <rect width="600" height="600" fill="#fff" />
          <rect width="300" height="600" fill="#002395" />
        </svg>
        <svg *ngIf="currentLang() === 'EN'" width="20" height="15" viewBox="0 0 60 30"
          xmlns="http://www.w3.org/2000/svg">
          <clipPath id="s-breadcrumb">
            <path d="M0,0 v30 h60 v-30 z" />
          </clipPath>
          <clipPath id="t-breadcrumb">
            <path d="M30,15 h30 v15 z v-30 h-30 z h-30 v15 z v-15 h30 z" />
          </clipPath>
          <g clip-path="url(#s-breadcrumb)">
            <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
            <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" stroke-width="6" />
            <path d="M0,0 L60,30 M60,0 L0,30" clip-path="url(#t-breadcrumb)" stroke="#C8102E" stroke-width="4" />
            <path d="M30,0 v30 M0,15 h60" stroke="#fff" stroke-width="10" />
            <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" stroke-width="6" />
          </g>
        </svg>
      </div>
      <!-- Icône flèche dropdown -->
      <div class="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none">
        <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
        </svg>
      </div>
    </div>

    <!-- ============================= -->
    <!-- AIDE & SUPPORT -->
    <!-- ============================= -->
    <button (click)="openHelpModal()" class="flex items-center space-x-2 p-2 hover:bg-gray-100 rounded-lg transition-colors">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2.25C6.615 2.25 2.25 6.615 2.25 12C2.25 17.385 6.615 21.75 12 21.75C17.385 21.75 21.75 17.385 21.75 12C21.75 6.615 17.385 2.25 12 2.25ZM12 14.747C12.1989 14.747 12.3897 14.826 12.5303 14.9667C12.671 15.1073 12.75 15.2981 12.75 15.497V15.997C12.75 16.1959 12.671 16.3867 12.5303 16.5273C12.3897 16.668 12.1989 16.747 12 16.747C11.8011 16.747 11.6103 16.668 11.4697 16.5273C11.329 16.3867 11.25 16.1959 11.25 15.997V15.497C11.25 15.2981 11.329 15.1073 11.4697 14.9667C11.6103 14.826 11.8011 14.747 12 14.747ZM13.872 7.933C14.416 8.415 14.75 9.121 14.75 9.99C14.75 10.63 14.586 11.128 14.3 11.533C14.044 11.898 13.712 12.147 13.477 12.323L13.45 12.343C13.187 12.541 13.034 12.663 12.926 12.817C12.836 12.944 12.75 13.134 12.75 13.497C12.75 13.6959 12.671 13.8867 12.5303 14.0273C12.3897 14.168 12.1989 14.247 12 14.247C11.8011 14.247 11.6103 14.168 11.4697 14.0273C11.329 13.8867 11.25 13.6959 11.25 13.497C11.25 12.857 11.414 12.357 11.7 11.953C11.956 11.589 12.288 11.34 12.523 11.163L12.55 11.143C12.813 10.945 12.966 10.823 13.074 10.669C13.164 10.542 13.25 10.352 13.25 9.99C13.25 9.53 13.084 9.24 12.878 9.056C12.6322 8.85025 12.3205 8.74016 12 8.746C11.66 8.746 11.343 8.86 11.123 9.056C10.916 9.239 10.75 9.53 10.75 9.99C10.75 10.1889 10.671 10.3797 10.5303 10.5203C10.3897 10.661 10.1989 10.74 10 10.74C9.80109 10.74 9.61032 10.661 9.46967 10.5203C9.32902 10.3797 9.25 10.1889 9.25 9.99C9.25 9.121 9.584 8.415 10.127 7.933C10.6472 7.48423 11.313 7.24005 12 7.246C12.66 7.246 13.343 7.464 13.872 7.933Z" fill="#063970"/>
      </svg>
      <div class="text-left">
        <div class="font-bold text-[#063970] text-sm">{{ t('breadcrumb.helpSupport') }}</div>
      </div>
    </button>
  </div>

  <!-- ============================= -->
  <!-- MODAL DÉTAILS NOTIFICATION -->
  <!-- ============================= -->
  <div 
    *ngIf="showNotificationModal && selectedNotification" 
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
    (click)="closeNotificationModal()">
    <div class="bg-white rounded-lg shadow-xl max-w-lg w-full" (click)="$event.stopPropagation()">
      <!-- Header -->
      <div class="bg-gradient-to-r from-[#063970] to-[#084a8c] px-6 py-4 flex items-center justify-between rounded-t-lg">
        <h2 class="text-lg font-bold text-white flex items-center gap-2">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"></path>
          </svg>
          {{ t('notifications.notificationDetails') }}
        </h2>
        <button (click)="closeNotificationModal()" class="text-white hover:text-gray-200 transition-colors">
          <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <!-- Content -->
      <div class="p-6 space-y-4">
        <!-- Titre -->
        <div>
          <label class="text-xs font-semibold text-gray-500 uppercase tracking-wide">{{ t('notifications.titleLabel') }}</label>
          <p class="mt-1 text-base font-semibold text-gray-900">{{ selectedNotification.libelle }}</p>
        </div>

        <!-- Description -->
        <div>
          <label class="text-xs font-semibold text-gray-500 uppercase tracking-wide">{{ t('notifications.descriptionLabel') }}</label>
          <p class="mt-1 text-sm text-gray-700 leading-relaxed">{{ selectedNotification.description }}</p>
        </div>

        <!-- Date et heure -->
        <div class="flex items-center justify-between pt-4 border-t border-gray-200">
          <div class="flex items-center text-sm text-gray-600">
            <svg class="w-5 h-5 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
            </svg>
            <span>{{ formatNotificationDate(selectedNotification.date) }}</span>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="border-t border-gray-200 px-6 py-4 bg-gray-50 rounded-b-lg">
        <button 
          (click)="closeNotificationModal()"
          class="w-full bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded-lg font-medium transition-colors">
          {{ t('common.close') }}
        </button>
      </div>
    </div>
  </div>

  <!-- ============================= -->
  <!-- MODAL AIDE & SUPPORT -->
  <!-- ============================= -->
  <div *ngIf="showHelpModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
    (click)="closeHelpModal()">
    <div class="bg-white rounded-lg shadow-xl max-w-md w-full animate-in" (click)="$event.stopPropagation()">
      <!-- Header -->
      <div
        class="bg-gradient-to-r from-[#063970] to-[#084a8c] px-6 py-4 flex items-center justify-between rounded-t-lg">
        <h2 class="text-xl font-bold text-white flex items-center gap-2">
          <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z">
            </path>
          </svg>
          {{ t('help.title') }}
        </h2>
        <button (click)="closeHelpModal()" class="text-white hover:text-gray-200 transition-colors">
          <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <!-- Content -->
      <div class="p-6 space-y-6">
        <!-- Description -->
        <p class="text-gray-600 text-sm">{{ t('help.description') }}</p>

        <!-- Email Contact -->
        <div class="border border-gray-200 rounded-lg p-4 hover:border-[#063970] transition-colors">
          <div class="flex items-center justify-between mb-2">
            <label class="text-sm font-semibold text-gray-700 flex items-center gap-2">
              <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" style="color: #063970">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              {{ t('help.email') }}
            </label>
          </div>
          <div class="flex items-center justify-between bg-gray-50 p-3 rounded">
            <span class="text-gray-900 font-medium">{{ emailAddress }}</span>
            <button (click)="copyToClipboard(emailAddress)"
              class="bg-[#063970] hover:bg-[#084a8c] text-white px-3 py-1 rounded text-xs font-medium transition-colors flex items-center gap-1">
              <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z">
                </path>
              </svg>
              {{ t('common.copy') }}
            </button>
          </div>
        </div>

        <!-- Phone Contact -->
        <div class="border border-gray-200 rounded-lg p-4 hover:border-[#063970] transition-colors">
          <div class="flex items-center justify-between mb-2">
            <label class="text-sm font-semibold text-gray-700 flex items-center gap-2">
              <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" style="color: #063970">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              {{ t('help.phone') }}
            </label>
          </div>
          <div class="flex items-center justify-between bg-gray-50 p-3 rounded">
            <span class="text-gray-900 font-medium">{{ phoneNumber }}</span>
            <button (click)="copyToClipboard(phoneNumber)"
              class="bg-[#063970] hover:bg-[#084a8c] text-white px-3 py-1 rounded text-xs font-medium transition-colors flex items-center gap-1">
              <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z">
                </path>
              </svg>
              {{ t('common.copy') }}
            </button>
          </div>
        </div>

        <!-- Hours -->
        <div class="rounded-lg p-4" style="background-color: rgba(6, 57, 112, 0.1); border: 1px solid #063970">
          <p class="text-sm" style="color: #063970">
            <span class="font-semibold">{{ t('help.hours') }}</span> {{ t('help.hoursValue') }}
          </p>
        </div>
      </div>

      <!-- Footer -->
      <div class="border-t border-gray-200 px-6 py-4 bg-gray-50 rounded-b-lg">
        <button (click)="closeHelpModal()"
          class="w-full bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded-lg font-medium transition-colors">
          {{ t('common.close') }}
        </button>
      </div>
    </div>
  </div>
</div>